var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManufacturingRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8, 8) scale(0.032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.71,68.622V1.213h-20.851v67.41h-61.342V1.213h-20.851v67.41h-61.331V1.213h-20.851v67.41H0v420.165h490V68.622H414.71       z M211.921,467.936H89.889V279.455c0-30.784,25.046-55.829,55.824-55.829h10.375c30.788,0,55.833,25.045,55.833,55.829V467.936z       M469.149,467.936H232.772V279.455c0-42.283-34.402-76.68-76.684-76.68h-10.375c-42.282,0-76.675,34.396-76.675,76.68v188.481       H20.851V89.473h448.298V467.936z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.725,
    y: 149.344,
    width: 59.428,
    height: 20.851
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.732,
    y: 149.344,
    width: 59.428,
    height: 20.851
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.725,
    y: 214.31,
    width: 59.428,
    height: 20.851
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.732,
    y: 214.31,
    width: 59.428,
    height: 20.851
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.725,
    y: 279.276,
    width: 59.428,
    height: 20.852
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.732,
    y: 279.276,
    width: 59.428,
    height: 20.852
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturingRequest);
export default __webpack_public_path__ + "static/media/manufacturing-request.4d92d31d0e295813a7af28abd458548f.svg";
export { ForwardRef as ReactComponent };